module.exports = {
  __init__: [ 'bpmnRenderer' ],
  bpmnRenderer: [ 'type', require(4) ],
  pathMap: [ 'type', require(5) ]
};
